export default "__VITE_ASSET__DJ3Yr2$g__"